<template>
    <div v-if="isShow" :style="domStyle">
        <!-- 请在此添加代码 -->
        <div ref="funnelChart" style="height: 100%; width: 100%"></div>
        <Icon type="ios-settings" size="20" class="setting" @click="modal1 = true"/>
         <Modal v-model="modal1" :z-index="2000">
      <div>
        <Row>
          <Col span="15">
            <Form :model="formItem" :label-width="80">
              <FormItem :label="addFunnelChart.funnelChartName">
                <Input
                  v-model="formItem.funnelChartName"
                  :placeholder="addFunnelChart.name"
                />
              </FormItem>
              <FormItem :label="addFunnelChart.funnelChartTag">
                <Row>
                  <Col span="16">
                    <Input
                      v-model="formItem.funnelChartTag"
                      :placeholder="addFunnelChart.tag"
                    />
                  </Col>
                  <Col span="4" offset="1">
                    <Button @click="addPoint">{{ addFunnelChart.getTag }}</Button>
                  </Col>
                </Row>
              </FormItem>

              <FormItem :label="addFunnelChart.color">
                <Row>
                  <Col span="4">
                    <ColorPicker v-model="formItem.funnelChartColor" recommend />
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel">取消</Button>
        <Button type="primary" size="large" @click="ok">确定</Button>
      </div>
    </Modal>
        <div v-if="isEnable" :style="enableStyle"></div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['primitives', 'fvSystemApi', 'parentObject'],
    data() {
        return {
            // 是否可用
            isEnable: false,
            // 是否显示
            isShow: true,
            // 组件大小位置,在created(创建完毕，挂载前)函数中初始化
            domStyle: {},
            option: {},
            dataName: [],
            modal1: false,
            dataColor: [],
            addFunnelChart: {},
            // 存储实时数据
            virtualData: [],
            // 历史数据
            historyData: [],
            hisStep: 0,
            formItem: {
                funnelChartName: "",
                funnelChartTag: "",
                funnelChartColor: "#19be6b"
            },
            ofNumber: 0
        };
    },
    methods: {
        //弹窗确定按钮
    ok() {
      if (this.formItem.funnelChartTag != "" && this.formItem.funnelChartName != "") {
        let addObj = {
          color: this.formItem.funnelChartColor,
          name: this.formItem.funnelChartName,
          tagName: this.formItem.funnelChartTag
        };
        this.data.push(addObj);
        let name = addObj.tagName;
        name = name.replace(/.PV/g, "");
        this.dbVar.push(name);
        this.realOrHis();
        this.modal1 = false;
        this.formItem.funnelChartTag = "";
        this.formItem.funnelChartName = "";
      } else {
        if (this.formItem.funnelChartTag == "") {
          alert("未选择点！");
        } else if (this.formItem.funnelChartName == "") {
          alert("没有输入内容!");
        }
      }
    },
    //弹窗关闭按钮
    cancel() {
      this.modal1 = false;
    },
    /*
          参数：无
          作用：获取点列表从而对表单数据进行添加
      */
    addPoint() {
      if (window.isApp()) {
        this.showDataDialog().then(
          function(req) {
            if (req) {
              this.formItem.funnelChartTag = req.name;
              if (this.formItem.isCurveName) {
                this.formItem.funnelChartName = req.desc;
              }
            }
          }.bind(this)
        );
      } else {
        this.showTagSelectDialog().then(
          function(req) {
            if (req) {
              this.formItem.funnelChartTag = req.name;
              if (this.formItem.isCurveName) {
                this.formItem.funnelChartName = req.desc;
              }
            }
          }.bind(this)
        );
      }
    },
    async showDataDialog() {
      var tagName;
      await this.fvSystemApi.selectDataShow().then(function(name) {
        tagName = name;
      });
      return tagName;
    },
    /*
          参数：无
          作用：获取点列表数据
      */
    async showTagSelectDialog() {
      var tagName;
      await this.fvSystemApi
        .selectTagsShow("Test.测试1.tag1.PV", true, true, true)
        .then(function(name) {
          tagName = name;
        });
      return tagName;
    },
        // 初始化
        create() {
            this.mixin(this.primitives);
            this.domStyle = {
                position: 'absolute',
                left: this.x + 'px',
                top: this.y + 'px',
                width: this.width + 'px',
                height: this.height + 'px',
                texteAlign: 'center',
                lineHeight: this.height + 'px'
            };

            this.enableStyle = {
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: '0px',
                backgroundColor: '#ccbfbf',
                opacity: '0.5'
            };
            this.option = {
                title: {
                    text: this.title, // 标题
                    subtext: this.getSubText(),
                    x: this.titleLocation, // 标题位置
                    textStyle: {
                        color: this.titleColor // 标题颜色
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c}'
                },

                legend: {
                    bottom: 'bottom', // 图例的位置
                    data: [] // 图例
                },
                backgroundColor: this.backgroundColor, // 背景色
                series: [
                    {
                        name: this.title,
                        type: 'funnel',
                        left: '10%',
                        width: '80%',
                        min: 0,
                        max: 100,
                        minSize: '0%',
                        maxSize: '100%',
                        sort: this.orientType, // 数据的排序
                        gap: 2,
                        label: {
                            show: true,
                            position: 'inside'
                        },
                        labelLine: {
                            length: 10,
                            lineStyle: {
                                width: 1,
                                type: 'solid'
                            }
                        },
                        itemStyle: {
                            borderColor: '#fff',
                            borderWidth: 1
                        },
                        emphasis: {
                            label: {
                                fontSize: 20
                            }
                        },
                        data: [
                            // 数据
                        ]
                    }
                ]
            };
        },
        // 将Json添加数据到当前对象
        mixin(src) {
            for (var key in src) {
                this[key] = src[key];
            }
        },
        /*
          参数：e 鼠标信息
               domScale 窗口放大、缩小、偏移等信息
          作用：鼠标事件调用函数，无必要可不进行任何处理
              */
        doFixedEvent(e, domScale) {
        },
        /*
                  参数：无
                  作用：系统周期调用
              */
        onTimer() {
            if(this.isEnable) return;
            if(this.dataType == 'historyData') return;
            this.ofNumber++;
            if(this.ofNumber % this.hisStep == 0) {
                this.getData();
            }
        },
        /*
                  参数：无
                  作用：所在窗口关闭时调用（vue生命周期函数销毁窗口之前调用）
              */
        onClose() {
            return new Promise((resolve) => {
                resolve();
            });
        },
        /*
                  参数：scaleObj 重绘信息
                  作用：组件需要重绘时触发
              */
        reDraw(scaleObj) {
            this.scaleObj = scaleObj;
            if(this.fontSize) {
                this.domStyle.fontSize = parseInt(parseInt(this.fontSize.substr(0, fontSize.length - 2)) * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + 'px';
            }
            this.domStyle.left = parseInt(this.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.ox) + 'px';
            if(this.$parent.fctype != 'fvGroupObj') {
                this.domStyle.top = parseInt(this.y * (scaleObj.sy + scaleObj.zoom) + scaleObj.oy) + 1 + 'px';
            } else {
                this.domStyle.top = parseInt(this.y * (scaleObj + scaleObj.zoom) + scaleObj.oy) + this.parentObject.heightTitle + 'px';
            }
            this.domStyle.width = parseInt(this.width * (scaleObj.sx + scaleObj.zoom)) + 'px';
            this.domStyle.height = parseInt(this.height * (scaleObj.sx + scaleObj.zoom)) + 'px';
            this.$refs.funnelChart.style.width = this.domStyle.width;
            this.$refs.funnelChart.style.height = this.domStyle.height;
            this.myChart.resize();
        },
        /*
                参数：isShow 显示隐藏
                作用：设置组件整体显隐
            */
        Show: function (isShow) {
            this.isShow = !!isShow;
        },
        /*
                参数：isEnable 是否可用
                作用：设置组件是否可用
            */
        Enable: function (isEnable) {
            this.isEnable = !isEnable;
        },
        // 视图数据更新
        drawFunnle() {
            this.myChart.setOption(this.option);
        },
        // 获取实时数据
        getData() {
            setTimeout(() => {
                for (let index = 0; index < this.data.length; index++) {
                    let realNum = this.fvSystemApi.getReal(this.data[index].tagName);
                    this.data[index]['value'] = realNum == undefined ? -9999 : realNum;
                }
                for (const key in this.data) {
                    this.$set(this.virtualData, key, this.data[key]);
                }
                this.updateData();
            }, 0);
        },
        // 更新视图数据
        updateData() {
            let legend = [];
            let option = this.myChart.getOption();
            // 判断是实时数据还是历史数据
            if(this.dataType != 'historyData') {
                this.realDate.forEach((value) => {
                    legend.push(value.name);
                });
                // 改变视图.
                this.realDate.forEach(element => {
                    element.value=element.value.PV
                });
                option.series[0].data = [];
                option.legend[0].data = [];
                option.legend[0].data = [...legend];
                option.series[0].data = [...this.realDate];
            } else {
                this.hisData.forEach((value) => {
                    legend.push(value.name);
                });
                // 改变视图.
                option.series[0].data = [];
                option.legend[0].data = [];
                option.legend[0].data = [...legend];
                option.series[0].data = [...this.hisData];
            }

            this.myChart.setOption(option);
        },
        // 根据时间获取历史数据
        makeMessage() {
            // if (!this.hisStep) {
            //   // 时间 2秒  1分 0时
            //   switch (Number(this.timeType)) {
            //     case 0:
            //       this.hisStep = Number(this.timeStep * 3600);
            //       break;
            //     case 1:
            //       this.hisStep = Number(this.timeStep) * 60;
            //       break;
            //     case 2:
            //       this.hisStep = Number(this.timeStep);
            //       break;
            //   }
            // }
            if(this.data.length <= 0) {
                return null;
            }
            let varList = [];
            for (let index = 0; index < this.dbVar.length; index++) {
                varList.push(this.dbVar[index].split("$").join(""));
                // varList.push(this.dbVar[index]);
            }
            // 判断是不是历史数据
            if(this.dataType != 'historyData') {
            } else {
                // 获取设置的时间
                var startTime = new Date(this.startTime.replace(/-/g, '/')).getTime();
                var endTime = new Date(this.endTime.replace(/-/g, '/')).getTime();
            }
            let hisType = 0;
            let hisMessage = {
                head: 'dataLayer',
                message: {
                    head: 'getHisData', // 请求头 getHisData
                    varList: varList, // 变量 格式(数组)
                    startTime: startTime, // 开始时间 格式(时间戳)
                    endTime: endTime, // 结束时间 格式(时间戳)
                    hisType: hisType, // 0真实历史值 1步长历史值
                    hisStep: this.hisStep // 时间间隔 格式(数字)
                }
            };
            return hisMessage;
        },
        // 获取历史数据
         async getHistory() {
            try {
                const res = await this.fvSystemApi.getHistory(this.makeMessage());
                // 处理获取的历史数据
                res.varList.forEach((item, index) => {
                    let pvList = [];
                    item.valueList.forEach((e, i) => {
                        pvList.push(e.PV);
                    });
                    // 判断数据格式
                    if(this.statisticStyle === 'average') {
                        this.data[index].value = this.average(pvList).toFixed(2);
                    } else if(this.statisticStyle === 'max') {
                        this.data[index].value = this.maximum(pvList).toFixed(2);
                    } else {
                        this.data[index].value = this.minimum(pvList).toFixed(2);
                    }
                });
                for (const key in this.data) {
                    this.$set(this.historyData, key, this.data[key]);
                }
                this.updateData();
            } catch (e) {
                console.log(e);
            }
        },
        // 历史数据>>>>计算平均值
        average(data) {
            let sum = 0;
            data.forEach(value => {
                sum += value;
            });
            return sum / data.length;
        },
        // 历史数据>>>>计算最大值值
        maximum(data) {
            return Math.max(...data);
        },
        // 历史数据>>>>计算最小值值
        minimum(data) {
            return Math.min(...data);
        },
        // 开始时间
        GetStartTime() {
            return this.startTime;
        },
        // 结束时间
        GetEndTime() {
            return this.endTime;
        },
        // 设置结束时间
        SetStartTime(dataStartTime) {
            if(new Date(dataStartTime).getTime() > new Date().getTime()) {
                this.startTimeOut = true;
                this.$Message.error(
                        '开始时间已超出当前时间-' + dataStartTime + '-' + new Date()
                );
                return;
            }
            this.startTimeOut = false;
            this.startTime = dataStartTime;
        },
        // 设置结束时间
        SetEndTime(dataEndTime) {
            if(new Date(dataEndTime).getTime() > new Date().getTime()) {
                if(this.startTimeOut == true) {
                    this.endTimeOut = true;
                    this.$Message.error(
                            '结束时间以超出当前时间-' + dataEndTime + '-' + new Date()
                    );
                }
                this.endTimeOut = false;
                return;
            }
            this.endTime = dataEndTime;
        },
        // 获取时间间隔
        GetTimeStep() {
            // 时间 2秒  1分 0时
            switch (Number(this.timeType)) {
                case 0:
                    this.hisStep = Number(this.timeStep * 3600);
                    break;
                case 1:
                    this.hisStep = Number(this.timeStep) * 60;
                    break;
                case 2:
                    this.hisStep = Number(this.timeStep);
                    break;
            }
        },
        // 设置时间间隔
        SetTimeStep(dataTimeStep) {
            this.timeStep = dataTimeStep;
        },
        // 获取副标题
        getSubText() {
            let subtext;
            if(this.dataType == 'historyData') {
                subtext = '历史数据';
            } else {
                subtext = '实时数据';
            }
            return subtext;
        },
        // 设置获取实时数据的轮询
        freshData() {
            this.getData();
            this.realTimeData = setInterval(() => {
                this.getData();
            }, (this.hisStep * 1000));
        },
        // 判断 实时or历史
        realOrHis() {
            if(this.dataType == 'historyData') {
                this.getHistory();
            } else {
                this.getData();
            }
        }
    },
    computed: {
        realDate() {
            let disposeData = [];
            // 将实时数据处理展示数据
            this.virtualData.forEach((el) => {
                disposeData.push({
                    name: el.name,
                    value: el.value,
                    itemStyle: {
                        normal: {
                            color: el.color
                        }
                    }
                });
            });
            return disposeData;
        },
        hisData() {
            let disposeData = [];
            this.historyData.forEach((el) => {
                disposeData.push({
                    name: el.name,
                    value: el.value,
                    itemStyle: {
                        normal: {
                            color: el.color
                        }
                    }
                });
            });
            return disposeData;
        }
    },
    created() {
        // 组件数据混淆
        this.mixin(this.primitives);
        // 窗口边框宽度。计算图元和组件位置时需要
        this.defaultTailoring = this.parentObject.defaultTailoring;
        // 窗口大小
        this.windowSize = this.parentObject.windowSize;
        // 创建组件
        this.create();
        this.modelsPath = this.parentObject.modelsPath.slice(0);
        this.modelsPath.push(this.registerName);
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this
            }
        });

        this.GetTimeStep();
    },
    mounted() {
        // 渲染图表
        this.myChart = this.$echarts.init(this.$refs.funnelChart);
        this.drawFunnle();
        this.realOrHis();
        this.addFunnelChartlist = {
        title: "添加数据",
        del: "删除",
        funnelChartName: "名称",
        funnelChartTag: "点",
        getTag: "获取点",
        color: "颜色",
        ok: "确定",
        close: "取消",
        tag: "点",
        name: "名称"
        };
        this.addFunnelChart = JSON.parse(JSON.stringify(this.addFunnelChartlist));
    },
    // 销毁定时接口
    destroyed() {
        clearInterval(this.realTimeData);
        this.realTimeData = null;
    }
};
</script>

<style scoped>
.setting {
    position: absolute;
    top: 6px;
    right: 0;
    cursor: pointer;
}

.realHeader {
    --bgColor: #f8f8f9;
    --borderColor: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/primitives/fvFunnelChart/fvFunnelChart.vue